import React from 'react';

import classes from './InnerToolbar.css';
import Logo from '../UI/Logo/Logo';
import NavigationItems from './NavigationItems/NavigationItems';

const toolbar = (props) => {
  // console.log('Toolbar props ::::',props);
  let isEqupmentRouter = false;
  let className = classes.Toolbar;
  if (props.selectedEquipment && Object.keys(props.selectedEquipment).length) {
    if (props.selectedEquipment.type) {
      className = classes['EquipmentHeader' + props.selectedEquipment.type];
    }
  }
  return (
    <header className={className}>
      <nav className={classes.DesktopOnly}>
        <NavigationItems
          realWan={props.realWan}
          selectedEquipment={props.selectedEquipment}
          isAuthenticated={props.isAuth}
          loggedinUserId={props.userId}
          success={props.success}
          error={props.error}
          onInitEquipment={props.onInitEquipment}
          changeEquipmentName={props.changeEquipmentName}
          locatePodDisplayLED={props.locatePodDisplayLED}
          setLocatePod={props.setLocatePod}
          realEquipment={props.realEquipment}
          wan={props.wan}
          checkingWan={props.checkingWan}
          podTimer={props.podTimer}
          realSettings={props.realSettings}
        />
      </nav>
    </header>
  );
}

export default toolbar;
